import '../Login/Login.scss';
import './Connect.scss';
import { ReactNode, useCallback, useState } from 'react';
import {
  ConnectFailure,
  ConnectFailureType,
  consentStepUrl,
  parseConnectQuery
} from '@src/utils/auth/oauth-client';
import { ConnectStep } from '@src/utils/auth/oauth-constants';
import { Login } from '../Login/Login';
import { LoginMode } from '../Login/login-constants';
import { ConnectConsent } from './ConnectConsent';
import { ConnectErrorView } from './ConnectErrorView';

// The /connect page: sign-in and consent for an MCP authorization transaction. It never touches the
// app session, so it renders outside the app's router and auth boot. What it shows comes from the
// URL the front redirected to (see parseConnectQuery) and, for consent, from the front's endpoints.
export const Connect = (): ReactNode => {
  const [query] = useState(() => parseConnectQuery(window.location.search));
  const [step, setStep] = useState(query.step);
  const [failure, setFailure] = useState<ConnectFailureType>(
    query.failure ?? ConnectFailure.UNKNOWN
  );
  const { tx } = query;

  const handleSignedIn = useCallback(() => {
    if (tx === undefined) return;
    // A reload after sign-in lands on consent instead of asking for the password again.
    window.history.replaceState(null, '', consentStepUrl(tx));
    setStep(ConnectStep.CONSENT);
  }, [tx]);

  const handleFailure = useCallback((next: ConnectFailureType) => {
    setFailure(next);
    setStep(ConnectStep.ERROR);
  }, []);

  if (step === ConnectStep.ERROR || tx === undefined) {
    return <ConnectErrorView failure={failure} reference={query.ref} target={query.target} />;
  }
  if (step === ConnectStep.CONSENT) {
    return <ConnectConsent tx={tx} onFailure={handleFailure} />;
  }
  return (
    <Login
      mode={LoginMode.AUTHORIZE}
      tx={tx}
      loginHint={query.loginHint}
      onSignedIn={handleSignedIn}
    />
  );
};
